import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';

import './Simulari.css';

export default function Simulari() {
    return (
        <Container className="simulariContainer worldwide">
            <p className="simulariTitle">
                <span className="bracket">{'<'}</span>
                    Simulări
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="simulariSubTitle">Află mai multe despre simulările pe care le organizez</p>
            <Row>
                <p className="simulariDescription">
                    În fiecare an, la finalul pregătirii pe care o organizez având în vedere promovarea concursurilor / examenelor
                    de Titularizare / Definitivat, încerc să organizez o simulare cu barem și rezolvări complete.
                </p>
                <Accordion alwaysOpen defaultActiveKey={['0']}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span># Simulări Proba Practică (2026-Prezent)</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="table-responsive">
                                <Table striped bordered hover size="lg" className="table-dark text-center" style={{verticalAlign: "middle"}}>
                                    <thead style={{verticalAlign: "middle"}}>
                                        <tr>
                                            <th>Anul</th>
                                            <th>Subiect</th>
                                            <th>Barem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>2026</td>
                                            <td><a href="/Simulari/proba-practica/Subiect Titularizare Informatică Proba Practică 2026.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/Simulari/proba-practica/Barem Titularizare Informatică Proba Practică 2026.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Accordion alwaysOpen defaultActiveKey={['1']}>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <span># Simulări Proba Scrisă (2026-Prezent)</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="table-responsive">
                                <Table striped bordered hover size="lg" className="table-dark text-center" style={{verticalAlign: "middle"}}>
                                    <thead style={{verticalAlign: "middle"}}>
                                        <tr>
                                            <th>Anul</th>
                                            <th>Subiect</th>
                                            <th>Barem</th>
                                            <th>Rezolvare</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>2026</td>
                                            <td><a href="/Simulari/proba-scrisa/Subiect Titularizare Informatică Proba Scrisă 2026.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/Simulari/proba-scrisa/Barem Titularizare Informatică Proba Scrisă 2026.pdf" className="fixColor" target="blank">Barem</a></td>
                                            <td><a href="/Simulari/proba-scrisa/Rezolvare Titularizare Informatică Proba Scrisă 2026.pdf" className="fixColor" target="blank">Rezolvare</a></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
        </Container>
    )
}